import { ReactElement } from 'react';
import { Route } from 'react-router-dom';

export const routerMap = ({ path, element, nestedRoutes, hidden }: any, index: number): ReactElement | null =>
  !hidden ? (
    <Route key={path + '-' + index} path={path} element={element}>
      {nestedRoutes ? nestedRoutes.map(routerMap) : null}
    </Route>
  ) : null;
